import { createSelector } from 'reselect';
import _ from 'lodash';

import { RootState } from '..';

export const selectSettings = (state: RootState) => {
  return state.settings;
};

export const selectLang = (state: RootState) => {
  return state.settings.lang;
};

export const selectTexts = createSelector(selectSettings, selectLang, (settings, lang) => {
  return settings.texts[lang];
});

export const selectCreateHub = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'createHub', {});
});

export const selectLogin = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'login', {});
});

export const selectGeneralTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'general', {});
});

export const selectSeoTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'seo', {});
});

export const selectTopSectionTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'topSection', {});
});

export const selectFormTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'form', {});
});

export const selectFormErrors = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'errors', {});
});
